import { render, staticRenderFns } from "./CommandArgs.vue?vue&type=template&id=1ba8edce&scoped=true"
import script from "./CommandArgs.vue?vue&type=script&lang=js"
export * from "./CommandArgs.vue?vue&type=script&lang=js"
import style0 from "./CommandArgs.vue?vue&type=style&index=0&id=1ba8edce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba8edce",
  null
  
)

export default component.exports